var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 542 584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{ \n        stroke-width: 0px;\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_orange",
    "data-name": "icon orange"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    className: "cls-1",
    d: "m430.52,33.5H113.95c-56.31,0-101.96,45.65-101.96,101.96v316.58c0,56.31,45.65,101.96,101.96,101.96h316.58c56.31,0,101.96-45.65,101.96-101.96V135.46c0-56.31-45.65-101.96-101.96-101.96Zm-58.95,239.78c0,3.85-3.8,6.54-7.43,5.27l-80.7-27.55c-2.07-.71-4.21.83-4.21,3.01v113.9h-.22c-2.38,31.38-24.54,55.97-51.55,55.97-28.59,0-51.77-27.56-51.77-61.56s23.18-61.56,51.77-61.56c14.91,0,28.33,7.5,37.78,19.49v-75.46s0-72.76,0-72.76v-3.34c0-3.84,3.79-6.52,7.41-5.25l95.31,32.5c2.17.76,3.62,2.81,3.62,5.11v72.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.829a25f68cde8fcbe977264304b90c28.svg";
export { ForwardRef as ReactComponent };